export default "__VITE_ASSET__CbQJQuv9__"